import React from "react";
import { Card, Tooltip, Text } from "@merge-api/merge-javascript-shared";

export interface Props {
  /**
   * The smaller, gray text above the datum
   */
  label: string;

  /**
   * A string to show when the label is hovered
   */
  labelHoverText?: string;

  /**
   * A piece of text to show as the main datum for this pair - may also
   * be a custom element.
   */
  data: string | JSX.Element;
}

/**
 * This pair ties a label and a piece of data together for use in the sidebar on
 * a linked account detail page.
 */
const MetadataPair = ({ label, labelHoverText, data }: Props) => {
  return (
    <Card variant="none" className="bg-gray-0 flex flex-col py-2 px-4 gap-y-1">
      {/* label */}

      <Tooltip title={labelHoverText}>
        <Text variant="h6">{label}</Text>
      </Tooltip>

      {/* data / element */}
      <div className="flex flex-row w-full">{data}</div>
    </Card>
  );
};

export default MetadataPair;
